import { LevelsResources } from "../tools";
import { useFormState } from "react-final-form";
import { Button } from "@material-ui/core";
import { useDataProvider } from "react-admin";
import moment from "moment/moment";
import fileDownload from "js-file-download";
import { Parser } from "json2csv";
import _ from "lodash";

interface IDownloadRouteButton {
  index: number;
  isToSchool: boolean;
  school: ISchool;
}

const DownloadRouteButton = ({
  isToSchool,
  index,
  school,
}: IDownloadRouteButton) => {
  const { values } = useFormState();
  const provider = useDataProvider();

  const generateCsv = async (clonedFormData: any) => {
    // Populate level Id from student list
    const levelIds: number[] = Array.from(
      new Set(
        clonedFormData.route.routeLocations.flatMap((item: any) =>
          item.students.map((student: any) => student.levelId)
        )
      )
    );

    var levels = await LevelsResources(levelIds, provider);

    // Used to display custom column header label
    let routeLabel = "PM";
    let timeLabel = "PM Drop-Off Time";
    let pointLabel = "PM Drop-Off Point";
    if (isToSchool) {
      routeLabel = "AM";
      timeLabel = "AM Pick-Up Time";
      pointLabel = "AM Pick-Up Point";
    }

    const dataRows = clonedFormData.route.routeLocations.flatMap(
      (item: any) => {
        return item.students
          .sort((a: any, b: any) => a.id - b.id)
          .map((data: any) => {
            return {
              "Location Code": data.locationCode,
              "First Name": data.firstName,
              "Last Name": data.lastName,
              "Gender": data.gender,
              "Class": levels.length > 0 && _.find(levels, ["id", data.levelId])?.name,
              "Blk/Hse No": item.blockNumber,
              "Street Address": item.street,
              "Building": item.building,
              "Postal Code": item.postalCode,
              [routeLabel]: clonedFormData.route.name,
              [timeLabel]: moment(item.arrivedAt, "HH:mm").format("hh:mm A"),
              [pointLabel]: item.remark !== null ? item.remark : "",
            };
          });
      }
    );
    
    const parser = new Parser();
    fileDownload(
      parser.parse(dataRows),
      `${school.name}_${routeLabel}_${
        clonedFormData.route.name
      }_${moment().format("YYYYMMDDHHmmss")}.csv`
    );
  };

  return (
    <Button
      variant="contained"
      size="small"
      style={{
        fontSize: "10px",
        color: "white",
        backgroundColor: "#4F5B7B",
        fontWeight: "bold",
      }}
      onClick={() => {
        generateCsv(values);
      }}
    >
      Export Route in CSV
    </Button>
  );
};

export default DownloadRouteButton;
